// @workflow assistant.voice, assistant.attachments
/**
 * A refused request → its stable code, the same way for every coded assistant endpoint
 * (dictation, Read aloud): the body's `code` when it is one the contract lists, else the code the
 * contract gives that status (a web server's own error page has no JSON), else the fallback.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 *
 * @param {number} status
 * @param {{ code?: string }|null|undefined} body
 * @param {{ codes: readonly string[], byStatus: Readonly<Record<number, string>>, fallback: string }} table
 */
export function codeForRefusal(status, body, { codes, byStatus, fallback }) {
  const code = body && body.code;
  if (codes.includes(code)) return code;
  return byStatus[status] || fallback;
}
